// Fonction pour initialiser la dataLayer
export const initDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
};

// Fonction pour envoyer un événement à GTM
export const pushEvent = (eventName, params = {}) => {
    if (!window.dataLayer) {
        console.warn('dataLayer n\'est pas initialisé');
        return;
    }

    window.dataLayer.push({
        event: eventName,
        ...params
    });

    console.log(`Événement envoyé à GTM: ${eventName}`, params);
};

// Événements spécifiques basés sur le CSV
export const triggerMainNav = (section) => {
    pushEvent('main_nav', { section });
};

export const triggerSubNav = (section, chapter) => {
    pushEvent('sub_nav', { section, chapter });
};

export const triggerSubNavAction = (section, chapter, action, part = null) => {
    const params = { section, chapter, action };
    if (part) {
        params.part = part;
    }
    pushEvent('sub_nav_action', params);
};

// Fonction pour suivre les vues de page
export const trackPageView = (path) => {
    pushEvent('page_view', { page_path: path });
}; 